module.exports = __webpack_public_path__ + "static/media/logo.93659d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 980
// module chunks = 0